import React, { useEffect, useState } from "react";
import Navbar from "./A01_Navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  redirect,
} from "react-router-dom";
import Home from "../Home";
import Company from "../admin/comapny/Company";
import Branch from "../admin/branch/Branch";
import Staff from "../admin/staffs/Staff";
import Goods from "../base-forms/goods/Goods";
import TechWorklist from "../technician/TechWorklist";
import Customer from "../base-forms/basicdata/Customer";
import Physician from "../base-forms/basicdata/Physician";
import PatientRight from "../base-forms/basicdata/PatientRight";
import UserRule from "../base-forms/basicdata/UserRule";
import UserSetting from "../base-forms/basicdata/UserSetting";
import StaffType from "../base-forms/basicdata/StaffType";
import BranchPacs from "../base-forms/basicdata/BranchPacs";
import BranchPricelist from "../base-forms/basicdata/BranchPricelist";
import BranchPatientRight from "../base-forms/basicdata/BranchPatientRight";
import BranchWard from "../base-forms/basicdata/BranchWard";
import RadioWorklist from "../radi/RadioWorklist";
import TemplateList from "../radi/TemplateList";
import { useSelector } from "react-redux";
import RadioWorklistPassed from "../radi/RadioWorklistPassed";
import UserProfile from "../base-forms/basicdata/UserProfile";
import ExportExcel from "../admin/export-excel";
import DocutypeList from "../backoffice/b0001-docutypelist";
import DocuBranchSetup from "../backoffice/b0003-docubranch-setup";
import TechAppointment from "../technician/TechAppointment";
import AdminMonthlyWork from "../technician/AdminMonthlyWork";
import AdminRadDF from "../technician/AdminRadDF";

export default function RadRoutes(props) {
  const userDetail = useSelector((state) => state.user);
  const theme = useSelector((s) => s.theme.theme);

  const [startPage, setStartPage] = useState();

  const startChoice = {
    techworklist: <TechWorklist />,
    rdoworklist: <RadioWorklist />,
    company: <Company />,
  };

  useEffect(() => {
    getDestination();
  }, []);

  const getDestination = () => {
    let lineLoginRegister = sessionStorage.getItem(
      "line_login_register_request_state"
    );

    //**มีการขอลงทะเบียน Login ผ่านไลน์ */
    if (lineLoginRegister) {
      setStartPage(<UserProfile />);
    } else {
      let choice = startChoice[userDetail.userRule.linkto];
      if (choice) setStartPage(choice);
      else setStartPage(<Home />);
    }
  };

  return (
    <Router data-theme={theme.themeName}>
      <Navbar />
      <Routes>
        {/* <Route path="/" element={getDestination()} /> */}
        <Route path="/" element={startPage} />
        <Route path="/company" element={<Company />} />
        <Route path="/branch" element={<Branch />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/goods" element={<Goods />} />
        <Route path="/brchpricelist" element={<BranchPricelist />} />
        <Route path="/patient_right" element={<PatientRight />} />
        <Route path="/techworklist" element={<TechWorklist />} />
        <Route path="/brchcustomer" element={<Customer />} />
        <Route path="/brchphysician" element={<Physician />} />
        <Route path="/user_right" element={<UserRule />} />
        <Route path="/user_mng" element={<UserSetting />} />
        <Route path="/staff_type" element={<StaffType />} />
        <Route path="/pacs_server_barch" element={<BranchPacs />} />
        <Route path="/brch_pat_right" element={<BranchPatientRight />} />
        <Route path="/brch_ward" element={<BranchWard />} />
        <Route path="/rdoworklist" element={<RadioWorklist />} />
        <Route path="/rdowork_hist" element={<RadioWorklistPassed />} />
        <Route path="/template" element={<TemplateList />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/exportexcel" element={<ExportExcel />} />

        <Route path="/docutype" element={<DocutypeList />} />

        <Route path="/docubranch" element={<DocuBranchSetup />} />
        <Route path="/appointment" element={<TechAppointment />} />
        <Route path="/adminmonthly" element={<AdminMonthlyWork />} />
        <Route path="/radpayment" element={<AdminRadDF />} />

        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}
